import React from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { loadRegisteredUsers } from './actions';
import ListRegisteredUsers from './ListRegisteredUsers';
import {
  makeSelectLoading,
  makeSelectPage,
  makeSelectRegisteredUsers,
  makeSelectTotalPage,
} from './selectors';
import withI18next from '~/../hocs/_withI18next';
import Breadcrumb from '~/components/Breadcrumb';
import NextPageButton from '~/components/NextPageButton';
import Pagination from '~/components/Pagination';
import Config from '~/config';
import { urls } from '~/utils';

const styles = {
  iconLoading: {
    width: 25,
  },
};

@withI18next()
class LogsRegisteredUsers extends React.Component {
  getNextLink() {
    const { lng, page, totalPage } = this.props;
    if (page >= totalPage) {
      return {};
    }
    const nextPage = page + 1;
    const queryString = urls.convertToQueryStrings({
      page: nextPage,
    });

    return {
      asPath: `/registered-users?${queryString}`,
      query: { page: nextPage },
    };
  }

  render() {
    const { registeredUsers, page, totalPage, lng, t, loading } = this.props;
    return (
      <div className="logs-registered-users">
        <div className="container-fluid">
          <div className="breadcrumb-wrapper">
            <div className="col-sm-8 breadcrumb-left">
              <Breadcrumb title={t('registered_users')} />
            </div>
            <div className="pagination-right">
              <Pagination
                currentPage={page}
                totalPage={totalPage}
                onChange={this.onChangePage}
                query={{}}
                asPath="/registered-users"
                path="/registered-users"
              />
            </div>
          </div>
        </div>
        <div className="registered-users-container pt50 pb50">
          <h1
            className={`registered-users-title text-center color-${Config.serviceType}`}
          >
            {t('registered_users')}
          </h1>
          {loading ? (
            <center>
              <FontAwesomeIcon
                icon={faSpinner}
                fixedWidth
                style={styles.iconLoading}
                pulse
              />
            </center>
          ) : (
            <ListRegisteredUsers
              users={registeredUsers}
              className="registered-users-content"
            />
          )}
          <div className="text-center" style={{ padding: '16px 0' }}>
            {page < totalPage && (
              <NextPageButton
                pathname="/registered-users"
                query={this.getNextLink().query}
                as={this.getNextLink().asPath}
                t={t}
              />
            )}
          </div>
        </div>
        <style jsx global>
          {`
            .logs-registered-users .breadcrumb-wrapper {
              display: flex;
              padding: 5px 0;
            }
            .logs-registered-users .breadcrumb-wrapper .breadcrumb-left,
            .logs-registered-users .breadcrumb-wrapper .pagination-right {
              flex-basis: 0;
              flex-grow: 1;
              max-width: 100%;
              display: flex;
              align-items: center;
            }
            .logs-registered-users .breadcrumb-wrapper .pagination-right {
              justify-content: flex-end;
              padding-right: 15px;
            }

            .logs-registered-users .registered-users-title {
              font-size: 2em;
            }

            .logs-registered-users .registered-users-container {
              background: #f2f3f4;
              display: flex;
              flex-direction: column;
              align-items: center;
            }

            .logs-registered-users .registered-users-content {
              max-width: 700px;
              margin: 0 auto;
              background: transparent;
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
  registeredUsers: makeSelectRegisteredUsers(),
  page: makeSelectPage(),
  totalPage: makeSelectTotalPage(),
});
const mapDispatchToProps = (dispatch) => ({
  loadRegisteredUsers: (params) => dispatch(loadRegisteredUsers(params)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LogsRegisteredUsers);
